import { render, staticRenderFns } from "./flexLine.vue?vue&type=template&id=2482f390&scoped=true"
import script from "./flexLine.vue?vue&type=script&lang=js"
export * from "./flexLine.vue?vue&type=script&lang=js"
import style0 from "./flexLine.vue?vue&type=style&index=0&id=2482f390&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2482f390",
  null
  
)

export default component.exports